import React, { Component } from "react";
import { Row, Col, Grid } from "react-bootstrap";

import { Helmet } from "react-helmet";

import Sidebar from "../../Sidebar/Sidebar";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";

import BannerRectangleLarge from "../../Banner/BannerRectangleLarge";

import { translate, getLanguage } from "../../Translation/Translation";

class Terms extends Component {
  render() {
    return (
      <div>
        <Grid fluid className="no-padding">
          <Helmet>
            <title>Terms of Use | Openseas</title>
            <meta
              name="description"
              content="Ενημερωθείτε για τους όρους χρήσης της Openseas. Openseas, όλα τα δρομολόγια της Ελλάδας, της Ιταλίας, της Αλβανίας, της Τουρκίας και της Μεσογείου σε μία ιστοσελίδα. Κλείστε σήμερα το επόμενο σας ταξίδι."
            />
          </Helmet>
          <Row style={{ margin: "0px" }}>
            <Col style={{ margin: "0px" }}>
              <Header data={this.props} />
            </Col>
          </Row>
          <Row style={{ margin: "0px" }}>
            <div className="OSPageContainer">
              <div className="OSPageContent">
                <Row>
                  <div className="contactLabel" style={{ margin: "0px" }}>
                    {translate(getLanguage(), "Terms of Use")}
                  </div>
                  <strong>LIKNOSS WEB SITE TERMS OF USE</strong>
                  <br></br>
                  <br></br>
                  LIKNOSS websites (www.liknoss.com, www.openseas.gr) or mobile
                  properties, including related applications (collectively, this
                  "Site") have been created by "LIKNOSS S.A." ("LIKNOSS") to
                  offer information and services to users and visitors of the
                  Site. Please, read carefully the terms and conditions of use
                  of the Site. If you do not agree to these terms, you should
                  not proceed any further on the Site. In all cases,
                  users/visitors of the Site totally and unconditionally accept
                  the terms and conditions of use and fully comply with them.
                  Users who have full legal competency are entitled to use the
                  Site.Minors are not permitted to use this Site without the
                  express consent of an adult who is legally responsible for
                  them. Minors are not permitted to use the pages and services
                  of the Site which, pursuant to the law, are exclusively
                  addressed to adults.<br></br>LIKNOSS shall not be liable for
                  any use by users/visitors who do not meet the above criteria.
                  <br></br>
                  <br></br>
                  <strong>INTELLECTUAL AND INDUSTRIAL PROPERTY RIGHTS</strong>
                  <br></br>
                  The total Content of the Site (including but not limited to:
                  texts, graphics source code, photo, programs, articles,
                  information, data, diagrams, trademarks, markings, logos,
                  brand names, company names, etc.) is the intellectual property
                  of LIKNOSS or the Suppliers of its Content and is governed by
                  national, Community and international provisions on
                  Intellectual Property, and is made available to users strictly
                  for personal (non-commercial or non-for-profit) use. Any
                  copying, reproduction, transfer, saving, alteration,
                  republication, transmission, distribution, sale, release,
                  execution, download, translation, modification in any manner,
                  disclosure, propagation or otherwise use of the Content for
                  commercial or other purposes, in part or in summary, is
                  expressly forbidden without the prior express written consent
                  of LIKNOSS. LIKNOSS reserves all legal and/or contractual
                  rights, other than those expressly mentioned in this
                  paragraph.
                  <br></br>
                  All other trademarks, markings, brand names, company names,
                  graphics and logos which are registered marks and products of
                  the intellectual property of third parties and appearing on
                  the Site belong to their owners and are within their
                  responsibility, and their presence on our Site is not and
                  should not be considered as transfer or licensing or
                  assignment of their right of use.
                  <br></br>
                  <br></br>
                  <strong>OBLIGATIONS OF VISITORS/USERS</strong>
                  <br></br>
                  Users/visitors agree and accept to use the Site for lawful
                  purposes, and to comply with the code of ethics posted herein
                  and provided by the applicable law. Visitors/users must not
                  use the content and services of the Site of LIKNOSS for any
                  unlawful, unethical, unfair and abusive purposes, and must not
                  perform actions or omissions that could damage or impair the
                  Site or third parties or affect or endanger the provision of
                  services by LIKNOSS.
                  <br></br>
                  <br></br>
                  Users/visitors agree not to use the Site for the following
                  indicative purposes:
                  <br></br>
                  <ul>
                    <li>to cause damage to any third party, adult or minor.</li>
                    <li>
                      to transmit or gain access to content that affects any
                      third-party rights or is against the law and fair
                      practices/business ethics.
                    </li>
                    <li>
                      to gain access to, diffuse, process, corrupt and generally
                      affect in any way the personal data of users or third
                      parties.
                    </li>
                  </ul>
                  In all cases of unlawful use of the Site or against these
                  Terms and the law, users/visitors shall be obliged to
                  indemnify LIKNOSS for any liquidated and consequential damages
                  incurred as a result of the above actions.
                  <br></br>
                  <br></br>
                  <strong>
                    DISCLAIMER AND INTERNET LIMITATION OF LIABILITY
                  </strong>
                  <br></br>
                  The Site is provided on an "as is" basis. LIKNOSS shall make
                  no warranty or assume any liability or responsibility for the
                  suitability, reliability, completeness and accuracy of the
                  provided information or advice. LIKNOSS shall make every
                  effort to provide accurate, clear, correct, complete,
                  up-to-date and readily available information on the Site.
                  However, LIKNOSS shall make no warranty or assume any
                  liability or responsibility (not even through negligence) for
                  any damages which visitors/users may sustain as a result of
                  using the Site. The Content and Services are provided by
                  LIKNOSS on an "as is" basis, with no expressed or implied
                  warranty for satisfactory quality, suitability, inviolability
                  of compatibility, security and accuracy. By no means LIKNOSS
                  shall be liable for any damages (liquidated, special or
                  consequential such as lost profits, data, loss of earnings,
                  financial redress, etc.) incurred by users/visitors of the
                  Site, or third parties, on grounds related or not to the
                  operation and/or use of the Site, and/or failure to provide
                  services/information made available on the Site and/or any
                  unauthorized interventions of third parties to
                  products/services/information made available on the Site.
                  LIKNOSS shall make every effort for the proper functioning of
                  its Network, however it cannot guarantee that its Site or
                  servers (or any site or servers linked to it) will be
                  uninterrupted or error-free, free of viruses or other harmful
                  components. Therefore, LIKNOSS shall not be liable for
                  indemnity and/or recovery of any damages incurred as a result
                  of using its Site or servers.
                  <br></br>
                  Although LIKNOSS is neither obliged nor capable of controlling
                  the safety and content of webpages, it is entitled to suspend
                  access to any page should there be any breach of the laws and
                  these terms.
                  <br></br>
                  Force majeure: LIKNOSS shall not be liable for breach of these
                  Terms and Conditions due to force majeure.
                  <br></br>
                  <br></br>
                  <strong>SPECIAL PROVISIONS</strong>
                  <br></br>
                  LIKNOSS reserves the right to modify or update at any time
                  these terms of use and conditions for provision of services
                  and it undertakes to notify users/visitors of this Site of any
                  modification or change.
                  <br></br>
                  In the event that the use of any service of the Site is
                  governed by special terms of use, such terms shall apply
                  together with these Terms of Use. In the event of conflict,
                  the special terms of use of each service shall prevail.
                  <br></br> Force majeure includes but is not limited to
                  earthquake, fire, flood, war.
                  <br></br>
                  <br></br>
                  <strong>EXCLUSION OF ADVICE PROVIDED BY THIRD PARTIES</strong>
                  <br></br>
                  Under no circumstances does anything provided to the
                  users/visitors of our Site may constitute or be perceived,
                  whether directly or indirectly, as encouragement, advice or
                  incitement for any act or omission, and users/visitors should
                  exercise their discretion to evaluate anything that is
                  provided to them and should act on the basis of their own free
                  will, to the exclusion of any liability on our part.
                  <br></br>
                  <br></br>
                  <strong>HYPERLINKS TO OTHER WEBSITES</strong>
                  <br></br>
                  This Site accepts no liability as to the content and services
                  of other websites to which it connects through "hyperlinks" or
                  promotional banners and does not warrant their availability
                  nor is responsible for any damages caused by their use, as
                  visitors/users have access to them at their sole
                  responsibility.
                  <br></br>
                  Information about trips (companies, vessels, departure and
                  arrival times, prices and indications of ticket availability)
                  is directly provided by the electronic reservation systems of
                  ferry companies, and therefore LIKNOSS cannot provide any type
                  of guarantee neither is responsible for the correctness,
                  validity, thoroughness and accuracy of that information, nor
                  for the vendibility and the appropriateness for a specific
                  purpose, which are electronically distributed, with the
                  approval and license of ferry companies, to the network of
                  collaborating sales agencies, travel agencies and web sites
                  that cooperate with LIKNOSS, such as the sites of tourism
                  agencies. LIKNOSS guarantees the secure and accurate, without
                  any distortion, diffusion of that information, under the form
                  and content which is provided by the on-line reservation
                  systems of ferry companies, with the prerequisite that there
                  is none obstacle of technical or any other nature that
                  inhibits the diffusion of information. Information about
                  ticket prices does not include any probable discounts that
                  users are possibly eligible for and are offered by the ferry
                  companies under the framework of the commercial policy that
                  they apply. Information about availability is indicative and
                  applies just for the time period that is received through the
                  OpenSeas service, and therefore LIKNOSS does not guarantee its
                  validity at another time period and under any circumstances,
                  considering the fact that peculiarities and large demand might
                  arise at certain time periods throughout each year. The
                  content of the webpage is exclusively provided for personal
                  use and is prohibited to constitute an object of reproduction,
                  replication, modification, commercial exploitation, etc., by
                  any means from the user. The Open Seas logo and system, all
                  the texts and names, apart form the names that specify ferry
                  companies, and departure and arrival times, constitute an
                  intellectual and industrial property of LIKNOSS and are
                  protected by the relevant laws. The commercial names and logos
                  of ferry companies, travel agents, vessels et al, constitute
                  an industrial and intellectual property of the ferry companies
                  which collaborate with LIKNOSS and are protected by valid
                  regulations.
                  <br></br>
                  <br></br>
                  <strong>PERSONAL DATA PROTECTION</strong>
                  <br></br>
                  LIKNOSS has the right to process any personal data voluntarily
                  provided by users/visitors in accordance with the Greek and EU
                  laws. Users/visitors of the Site acknowledge and accept the
                  retention and processing of their personal data for the
                  reasons these are provided to LIKNOSS. LIKNOSS shall keep
                  personal data by using security procedures and providing the
                  highest possible level of safety and confidentiality to the
                  users' personal data. Every data subject has the right to know
                  whether his personal data has been or still is the object of
                  processing (right of access, Article 12, Law 2472/1997).
                  Access to our archives is possible only if he has legal
                  interest and right and upon the public prosecutor's order. The
                  data subject is entitled to raise objections anytime to the
                  processing of his data (right of objection, Article 13, Law
                  2472/1997).
                  <br></br>
                  At all instances users reserve the right to notification,
                  objection or other claim in relation to the further processing
                  of the personal information they have declared as correct,
                  according to the provisions of Law 2472/1997. Users/visitors
                  shall be liable for possible submission of personal data of
                  third parties to LIKNOSS without relevant authorization, as
                  well as for the submission of false, incorrect or inaccurate
                  information and data with the purpose of deception or
                  fraudulence.
                  <br></br>
                  <br></br>
                  <strong>Collected personal data:</strong>
                  <br></br>
                  In the event that access to wepages or services of the Site
                  requires a username and password and/or further information
                  (e.g. e-mail, first name, last name, landline number, mobile
                  number, age, address) users/visitors shall be solely
                  responsible for any leakage or arbitrary or unlawful use of
                  these by themselves or third parties.
                  <br></br>
                  The aforementioned data should always be correct, accurate,
                  valid and complete. Users/visitors shall be responsible for
                  all acts performed by using the Password and are obliged to
                  forthwith notify LIKNOSS of any unauthorized use thereof and
                  of any possible breach of security.
                  <br></br>
                  LIKNOSS shall not be liable for any damage or impairment
                  incurred due to the unauthorized or illegal use of the
                  Password by third parties, as a result of leakage or for any
                  other reason and reserves the right to ask for indemnification
                  from the user in the event that the company incurs any damage
                  due to the unauthorized or illegal use of the Password, and to
                  deny the provision of a Password or to cancel a given password
                  or to terminate these services to the user in the event of
                  breach of these Terms of Use.
                  <br></br>
                  <br></br>
                  <strong>APPLICABLE LAW - LIABILITY - FINAL PROVISIONS</strong>
                  <br></br>
                  The present terms of use shall be governed by the provisions
                  of the Greek Law, the Directives and Regulations of the
                  European Law, as well as the relevant international
                  provisions, and shall be interpreted according to the rules of
                  good faith, business ethics and the financial and social
                  purpose of the right. The invalidity of any particular term
                  hereof shall not affect the validity of the remaining terms,
                  but it shall automatically cease to apply. No modification of
                  the terms of the present terms shall be taken into
                  consideration and shall not be part thereof, unless formulated
                  in writing and integrated therein.<br></br>Disputes arising
                  from the execution of the present terms of use will be subject
                  to the exclusive jurisdiction of the courts of Athens. For any
                  further clarifications on the use of the Site, users/visitors
                  may send a written request at the following email address
                  info@openseas.gr
                </Row>
                <Row
                  className="BannerRectangleLarge"
                  style={{ margin: "40px 0 20px 0", textAlign: "center" }}
                >
                  <BannerRectangleLarge />
                </Row>
              </div>
              <div className="OSPageSidebar">
                <Sidebar />
              </div>
            </div>
          </Row>
          <Row style={{ margin: "0px" }}>
            <Footer />
          </Row>
        </Grid>
      </div>
    );
  }
}
export default Terms;



// WEBPACK FOOTER //
// ./src/components/Pages/Terms/Terms.js